import request from '@/utils/request'

// 下载任务错误明细
export function downloadTaskErrorDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/uploadTask/downloadDetail',
    method: 'POST',
    data,
  })
}

// 获取OCR错误日志
export function getOcrErrorDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/uploadTask/getOcrFailDetail',
    method: 'POST',
    data,
  })
}
// 获取OCR错误日志
export function checkOcrOpen(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/open/check',
    method: 'POST',
    data,
  })
}

// 查询OCR可用状态
export function queryOcrStatus(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/ocrStatus',
    method: 'POST',
    data,
  })
}

// 上传文件
export function uploadFile(data = {}, signal) {
  return request({
    timeout: 0, // 无限制的超时时间
    url: '/admin/v1/vehicle/fs/standard/upload',
    method: 'POST',
    data,
    signal,
  })
}

// oss 上传改造-测试版本
export function ossUploadFile(data = {}, signal) {
  return request({
    timeout: 0, // 无限制的超时时间
    url: '/admin/v1/vehicle/fs/standard/upload',
    method: 'POST',
    data,
    signal,
  })
}

// 证照文件校验
export function checkLicenseFile(data = {}) {
  return request({
    url: '/admin/v1/vehicle/fs/license/check',
    method: 'POST',
    data,
  })
}

/* 车辆看板 start */
// 车辆持有情况
export function getVehicleHoldInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/vehicleHoldInfo',
    method: 'POST',
    data,
  })
}

// 车辆出租情况-空置率
export function getVacancyRate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/vacancyRate',
    method: 'POST',
    data,
  })
}

// 车辆出租情况-出租率
export function getRentalRate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/rentalRate',
    method: 'POST',
    data,
  })
}

// 车辆出租情况-出租漏斗
export function getRentalFunnel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/rentalFunnel',
    method: 'POST',
    data,
  })
}

// 车辆出租情况-续租率
export function getRenewalRate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/renewalRate',
    method: 'POST',
    data,
  })
}

// 车辆资损情况-违章情况
export function getVehicleViolationInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/vehicleViolationInfo',
    method: 'POST',
    data,
  })
}

// 车辆资损情况-维修情况
export function getVehicleMaintenanceInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/vehicleMaintenanceInfo',
    method: 'POST',
    data,
  })
}

// 车辆资损情况-车辆折旧情况
export function getVehicleDepreciationInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/vehicleDepreciationInfo',
    method: 'POST',
    data,
  })
}

// 车辆资损情况-事故情况
export function getVehicleAccidentInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/vehicleAccidentInfo',
    method: 'POST',
    data,
  })
}

// 车辆资损情况-事故数量
export function getVehicleAccidentNumber(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/vehicleAccidentNumber',
    method: 'POST',
    data,
  })
}

// 获取分级情况（最新）
export function getGradeConfig(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/getGradeConfig',
    method: 'POST',
    data,
  })
}

// 获取分级情况
export function getGradeConfigRecord(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/getGradeConfigRecord',
    method: 'POST',
    data,
  })
}

// 添加或更新分级情况
export function saveGradeConfig(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/saveGradeConfig',
    method: 'POST',
    data,
  })
}

// 获取分级情况（违章管理，最新）
export function getViolationGradeConfig(data) {
  return request({
    url: '/admin/v1/vehicle/config/getByType',
    method: 'POST',
    data,
  })
}

// 获取分级情况（违章管理）
export function getViolationGradeConfigRecord(data) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/getViolationGradeConfigRecord',
    method: 'POST',
    data,
  })
}

// 添加或更新分级情况（违章管理）
export function saveViolationGradeConfig(data) {
  return request({
    url: '/admin/v1/vehicle/config/saveViolationConfig',
    method: 'POST',
    data,
  })
}

/* 车辆看板 end */

// 联动网约运营数据 start
// 车辆运营情况看板-统计信息
export function getVehicleOperateSummaryInfo(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/vehicle/summaryInfo',
    method: 'POST',
    data,
  })
}

// 车辆运营情况看板-图表
export function getVehicleOperateChartInfo(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/vehicle/chartInfo',
    method: 'POST',
    data,
  })
}

// 车辆运营情况看板-网约出车情况影响因子
export function getVehicleWorkImpactFactors(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/vehicle/workImpactFactors',
    method: 'POST',
    data,
  })
}

// 车辆运营情况看板-网约运营情况影响因子
export function getVehicleOperateImpactFactors(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/vehicle/operateImpactFactors',
    method: 'POST',
    data,
  })
}

// 车辆运营列表
export function getVehicleOperateList(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/vehicle/operateList',
    method: 'POST',
    data,
  })
}
// 车辆运营列表导出
export function exportVehicleOperateList(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/vehicle/operateList/export',
    method: 'POST',
    data,
  })
}
// 联动网约运营数据 end

/**
 * 批量录入车辆
 * @param {*} data
 * @returns
 */
export function batchCreateCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/import/batchCreateCar',
    method: 'POST',
    data,
  })
}

/**
 * 通知公共接口（目前包含申诉通知以及解约）
 */
export function getNotifyPopup(data = {}) {
  return request({
    url: '/admin/v1/vehicle/notify/pop',
    method: 'POST',
    data,
  })
}

// 禁用车型前置校验
export function disableVerification(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/disableVerification',
    method: 'POST',
    data,
  })
}
